import MongoDBIcon from "../assets/MongoDB.svg";
import MySQLIcon from "../assets/MySQL.svg";
import PostgreSQLIcon from "../assets/PostgresSQL.svg";
import SQLiteIcon from "../assets/SQLite.svg";
import RedisIcon from "../assets/Redis.svg";
import OracleIcon from "../assets/Oracle.svg";
import NeonDBIcon from "../assets/NeonDB.svg";

export function DatabaseLogos() {
  const databases = [
    {
      name: "MySQL",
      color: "#4479A1",
      icon: MySQLIcon,
    },
    {
      name: "PostgreSQL",
      color: "#4169E1",
      icon: PostgreSQLIcon,
    },
    {
      name: "MongoDB",
      color: "#00ED64",
      icon: MongoDBIcon,
    },
    {
      name: "SQLite",
      color: "#003B57",
      icon: SQLiteIcon,
    },
    {
      name: "Redis",
      color: "#DC382D",
      icon: RedisIcon,
    },
    {
      name: "Oracle",
      color: "#F80000",
      icon: OracleIcon,
    },
    {
      name: "NeonDB",
      color: "#00E599",
      icon: NeonDBIcon,
    },
  ];

  return (
    <section id="databases" className="relative py-24 px-6">
      <div className="max-w-5xl mx-auto text-center">
        {/* Section Header */}
        <p className="text-sm font-semibold text-emerald-400 uppercase tracking-wider mb-4">
          Universal Compatibility
        </p>
        <h2 className="text-3xl sm:text-4xl font-bold text-white mb-4">
          Connect to Any Database
        </h2>
        <p className="text-zinc-400 max-w-xl mx-auto mb-16">
          Seamlessly connect to all major database engines with a unified interface. 
          No more switching between different tools.
        </p>

        {/* Database Icons */}
        <div className="flex flex-wrap justify-center items-center gap-8 sm:gap-12">
          {databases.map((db, index) => (
            <div
              key={db.name}
              className="group flex flex-col items-center gap-3 db-icon opacity-0 animate-fade-in-up"
              style={{ 
                animationDelay: `${index * 100}ms`,
                animationFillMode: 'forwards'
              }}
            >
              <div 
                className="p-4 rounded-2xl bg-white/5 border border-white/10 group-hover:border-white/20 transition-all group-hover:shadow-lg"
                style={{ 
                  '--glow-color': db.color,
                  boxShadow: 'none'
                } as React.CSSProperties}
                onMouseEnter={(e) => {
                  (e.currentTarget as HTMLElement).style.boxShadow = `0 0 30px ${db.color}30`;
                }}
                onMouseLeave={(e) => {
                  (e.currentTarget as HTMLElement).style.boxShadow = 'none';
                }}
              >
                <img 
                  src={db.icon} 
                  alt={db.name}
                  className="w-12 h-12 object-contain transition-transform group-hover:scale-110"
                />
              </div>
              <span className="text-sm font-medium text-zinc-400 group-hover:text-white transition-colors">
                {db.name}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

